import { FC } from 'react'
import { Anchor } from 'interfaces/navigation'
import { useShouldBlockPage } from 'hooks/subscriptionHooks'
import { PremiumOnlyIcon } from 'components/features/pfm/PremiumOnlyIcon/PremiumOnlyIcon'

type PremiumOnlyIconNavigationLinkProps = {
  to: Anchor
}

export const PremiumOnlyIconNavigationLink: FC<PremiumOnlyIconNavigationLinkProps> = (props) => {
  const { to } = props

  const isBlocked = useShouldBlockPage(to)

  return (
    <PremiumOnlyIcon isBlocked={ !!isBlocked } />
  )
}
